import React from 'react'
import { Button } from './Button'
import './signIn.css'


export const SignIn = (props) => {

    return (
        <div className="SignInDiv">
            <section id="whenSignedOut">
                <div id="welcomeDiv">
                    <h1>Welcome</h1>
                    <h3>Please sign in.</h3>
                    {props.unauthorizedAttempt && (
                        <p style={{color: 'red', fontWeight: 'bold'}}>
                            Access denied. Your account is not authorized to use this application.
                        </p>
                    )}
                </div>
                <div id='googleButtonDiv'>
                <Button onClick={props.signInWithGoogle}
                type="button"
                buttonStyle="btn--primary--solid"
                buttonSize="btn--large"
                >
                Sign in with Google
                </Button>

                </div>

            
            </section>
        </div>
    )
}


